module.exports = __webpack_public_path__ + "img/Art11_20200359-001.f07c0eb7.jpg";